"use client";

import { useQueryHandler } from "@/hooks/use-query-handler";
import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import {
  InputGroup,
  InputGroupAddon,
  InputGroupButton,
  InputGroupInput,
} from "../ui/input-group";
import { SearchIcon } from "lucide-react";

function SearchInputCard({
  title,
  searchPlaceholder,
}: {
  title: string;
  searchPlaceholder: string;
}) {
  const { query, handleSearch } = useQueryHandler();

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <SearchIcon className="text-primary size-6" />
          {title}
        </CardTitle>
      </CardHeader>
      <CardContent>
        <InputGroup>
          <InputGroupInput
            defaultValue={query}
            placeholder={searchPlaceholder}
            onChange={(e) => handleSearch(e.target.value)}
          />
          <InputGroupAddon align="inline-end">
            <InputGroupButton variant="secondary">Rechercher</InputGroupButton>
          </InputGroupAddon>
        </InputGroup>
      </CardContent>
    </Card>
  );
}

export { SearchInputCard };
